import { Component, Input, ViewContainerRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ComponentType } from '@angular/cdk/overlay';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogWrapperEventService } from './dialog-wrapper-event.service';

@Component({
  templateUrl: './dialog-wrapper.component.html',
  styleUrls: ['./dialog-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DialogWrapperComponent {
  @Input() title: string;
  @Input() buttontext: string;
  componentType: ComponentType<any>;
  public dialogRef: MatDialogRef<any>;
  public childComponentInstance: any;

  @ViewChild('target', { read: ViewContainerRef, static: true })
  target: ViewContainerRef;

  constructor(private readonly dialogEvent: DialogWrapperEventService) {}

  public init() {
    if (this.componentType) {
      const componentRef = this.target.createComponent(this.componentType);
      this.childComponentInstance = componentRef.instance;
    }
  }

  public close() {
    this.dialogRef.close();
  }

  public submit() {
    if (this.childComponentInstance && typeof this.childComponentInstance.isValid === 'function') {
      const valid = this.childComponentInstance.isValid();
      if (valid) {
        const result = this.childComponentInstance.getData?.();
        this.dialogRef.close(result);
      }
    } else {
      this.dialogEvent.validateAndSave.emit();
    }
  }
}
